<script setup lang="ts">
import {ref} from "vue";
import {router} from "@inertiajs/vue3";

interface Props {
    id: number
}
const props = defineProps<Props>()

const isDialogOpen = ref(false)
const isLoading = ref(false)

const remove = () => {
    router.delete(route('settings.ssh_keys.destroy', {ssh_key: props.id}), {
        onStart: () => {
            isLoading.value = true;
        },
        onFinish: () => {
            isLoading.value = false;
        },
        onSuccess: () => {
            isDialogOpen.value = false
        }
    })
}
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        overlay-opacity="0.4"
    >
        <template #activator="{ props: attrs }">
            <default-btn
                v-bind="attrs"
                size="small"
                variant="text"
                rounded="lg"
                class="font-weight-medium text-error rounded border bg-grey-lighten-5"
            >
                Delete
            </default-btn>
        </template>

        <v-card
            :flat="true"
            rounded="lg"
        >
            <v-card-title class="font-weight-bold border-bottom text-body-2 pt-4">
                Are you sure you want to remove this SSH key?
                <v-btn
                    variant="plain"
                    size="small"
                    icon="mdi-close"
                    class="float-end pb-2"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="pt-3 text-black">
                <p class="text-body-2">
                    This action <b>CANNOT</b> be undone. This will permanently remove the SSH key and if you’d like to use it in the future, you will need to upload it again.
                </p>
            </v-card-text>

            <v-divider />

            <v-card-actions class="px-5 py-4">
                <default-btn
                    class="text-error border"
                    rounded="lg"
                    :block="true"
                    :loading="isLoading"
                    @click="remove"
                >
                    I understand, remove this SSH key
                </default-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
:deep(.v-dialog--active) {
  border-radius: 16px !important;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
